// 資料新鮮度：manifest 產生時間＋各來源最後成功時間（hover 顯示），來源異常時顯示提示條。
import type { Manifest } from '@dayone/core/snapshot';
import { t } from '../../i18n/zh-TW.ts';
import { timeAgo } from '../../lib/format.ts';
import { Hint } from '../../ui/Hint.tsx';

export function Freshness({ manifest, now }: { manifest: Manifest; now: number }) {
  const ago = timeAgo(manifest.generatedAt, now);
  const sources = Object.entries(manifest.sourceHealth);
  return (
    <Hint
      content={
        <div className="freshness-detail">
          <strong>{t.freshness.hintTitle}</strong>
          <ul>
            {sources.map(([id, h]) => (
              <li key={id}>
                <span className="source-name">{id.toUpperCase()}</span> {timeAgo(h.lastOkAt, now) ?? t.freshness.never}
                {h.degraded && <span className="badge badge-warn">{t.freshness.degraded}</span>}
              </li>
            ))}
          </ul>
        </div>
      }
    >
      <button type="button" className="freshness">
        <span
          className={Object.values(manifest.sourceHealth).some((h) => h.degraded) ? 'status-dot warn' : 'status-dot'}
          aria-hidden="true"
        />
        {ago ? t.freshness.updated(ago) : ''}
      </button>
    </Hint>
  );
}

export function SourceBanners({ manifest }: { manifest: Manifest }) {
  const degraded = Object.values(manifest.sourceHealth).some((h) => h.degraded);
  return (
    <>
      {manifest.mode === 'fixture' && (
        <div className="banner banner-info" role="note">
          {t.freshness.fixture}
        </div>
      )}
      {degraded && manifest.mode !== 'fixture' && (
        <div className="banner banner-warn" role="status">
          {t.freshness.degradedBanner}
        </div>
      )}
    </>
  );
}
